export default "__VITE_ASSET__D97_RNpP__"